import axios from 'axios'
import {
  PasswordWithRules,
  Rules,
  RegexRule,
  LengthRule,
  BlackListRule,
  MustMatchRule,
} from './components/Password/PasswordWithRules';
import {
  getInstance as getClientInstance,
  setBaseUrl as setClientBaseUrl,
  setToken as setClientToken,
} from './lib/client';
import accountUsersProviderSlice, {
  getAccountUsersProvider
} from './slices/accountUsersProvider'

import userLoginProviderSlice, {
  getUserLoginProviderDebounced,
  reset as resetUserLoginProvider
} from './slices/userLoginProvider'

export {
  userLoginProviderSlice,
  getUserLoginProviderDebounced,
  accountUsersProviderSlice,
  getAccountUsersProvider,
  PasswordWithRules,
  getClientInstance,
  setClientBaseUrl,
  setClientToken,
  Rules,
  RegexRule,
  LengthRule,
  BlackListRule,
  axios,
  MustMatchRule,
  resetUserLoginProvider,
};
